import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The panel's `SceneGraph`, which the shell parses. It is null until the first
 * successful parse, and a consumer then renders a passive loading state,
 * never a throw or a partial render (R3F-contracts.md §4).
 */
import { createContext, useContext } from 'react';
const HierarchyContext = createContext(null);
HierarchyContext.displayName = 'HierarchyContext';
export function HierarchyProvider({ value, children }) {
    return _jsx(HierarchyContext.Provider, { value: value, children: children });
}
export function useHierarchy() {
    const value = useContext(HierarchyContext);
    if (value === null) {
        throw new Error('useHierarchy must be used inside a <TscnPreviewShell> (HierarchyProvider). ' +
            'See R3F-contracts.md §4.');
    }
    return value;
}
/**
 * Returns `null` instead of throwing with no provider, so a canvas mounted
 * alone in a test still renders.
 */
export function useOptionalHierarchy() {
    return useContext(HierarchyContext);
}
//# sourceMappingURL=HierarchyContext.js.map